import { Component, OnInit, Inject, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


export interface MessageBoxData {
  messageText: string;
  type:number;
}

@Component({
  selector: 'app-message-box-dialog',
  templateUrl: './message-box-dialog.component.html',
  styleUrls: ['./message-box-dialog.component.css']
})
export class MessageBoxDialogComponent implements OnInit {


  @ViewChild('searchText') searchText: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<MessageBoxDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MessageBoxData) { }

  onNoClick(): void {

    console.log("Dialogo fechado onNoClick ");
    this.dialogRef.close();
  }

  closeDialog(): void {

    console.log("Dialogo fechado closeDialog ");

  
    this.dialogRef.close(true);
  }

  ngOnInit() {
  }



}


